import Usuario from './Usuario'
import FaixaAit from "./FaixaAit";
import Agente from "./Agente";
import OrgaoAutuacao from "./OrgaoAutuacao";

class Talonario {
    constructor(
        {
            id = null,
            numero_talao = null,
            orgao_autuacao_id = null,
            agente_responsavel_id = null,
            agente_autuador_id = null,
            faixa_ait_id = null,
            num_ait_inicial = null,
            num_ait_final = null,
            data_liberacao_grafica = null,
            usuario_geracao_id = null,
            data_entrega_orgao = null,
            usuario_entrega_orgao_id = null,
            data_atribuicao_agente = null,
            usuario_carga_agente_id = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,

            //ORM
            orgao_autuacao = {},
            agente_responsavel = {},
            agente_autuador = {},
            faixa_ait = {},
            usuario_geracao = {},
            usuario_entrega_orgao = {},
            usuario_carga_agente = {},
            usuario = {},
        } = {}
    ) {

        this.id = id;
        this.numero_talao = numero_talao;
        this.orgao_autuacao_id = orgao_autuacao_id;
        this.agente_responsavel_id = agente_responsavel_id;
        this.agente_autuador_id = agente_autuador_id;
        this.faixa_ait_id = faixa_ait_id;
        this.num_ait_inicial = num_ait_inicial;
        this.num_ait_final = num_ait_final;
        this.data_liberacao_grafica = data_liberacao_grafica;
        this.usuario_geracao_id = usuario_geracao_id;
        this.data_entrega_orgao = data_entrega_orgao;
        this.usuario_entrega_orgao_id = usuario_entrega_orgao_id;
        this.data_atribuicao_agente = data_atribuicao_agente;
        this.usuario_carga_agente_id = usuario_carga_agente_id;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;

        //ORM
        this.orgao_autuacao = orgao_autuacao ? new OrgaoAutuacao(orgao_autuacao) : new OrgaoAutuacao();
        this.agente_responsavel = agente_responsavel ? new Agente(agente_responsavel) : new Agente();
        this.agente_autuador = agente_autuador ? new Agente(agente_autuador) : new Agente();
        this.faixa_ait = faixa_ait ? new FaixaAit(faixa_ait) : new FaixaAit();
        this.usuario_geracao = usuario_geracao ? new Usuario(usuario_geracao) : new Usuario();
        this.usuario_entrega_orgao = usuario_entrega_orgao ? new Usuario(usuario_entrega_orgao) : new Usuario();
        this.usuario_carga_agente = usuario_carga_agente ? new Usuario(usuario_carga_agente) : new Usuario();
        this.usuario = usuario ? new Usuario(usuario) : new Usuario();
    }
}

export default Talonario;